/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './util/startup';
import {ControlVariant, ThemeProvider} from '@dvrd/dvr-controls';
import React, {useContext, useEffect, useState} from 'react';
import {Outlet, useLocation} from 'react-router';
import {AppContext} from './components/context/appContext';
import PopupController from './components/misc/popupController';
import User from './models/userModel';
import {BASE_COLOR, CONTRAST_COLOR} from './util/constants';

export default function App() {
    const {onChangeContext} = useContext(AppContext);
    const [validatingUser, setValidatingUser] = useState(true);
    const location = useLocation();

    function validateUser() {
        User.get((user: User | null) => {
            onChangeContext({user}, () => {
                setValidatingUser(false);
            });
        });
    }

    useEffect(() => {
        window.setTimeout(() => {
            document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
        });
    }, [location.pathname]);

    useEffect(() => {
        validateUser();
    }, []);

    return (
        <ThemeProvider theme={{
            baseColor: BASE_COLOR,
            contrastColor: CONTRAST_COLOR,
            controlVariant: ControlVariant.SIMPLE

        }}>
            <div className='page'>
                {!validatingUser && <Outlet/>}
            </div>
            <PopupController/>
        </ThemeProvider>
    );
}